if (!customElements.get('media-collage-scroll')) {
  customElements.define('media-collage-scroll', class MediaCollageScroll extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.timeouts = [];
      this.resizeObserver = null;
      this.observer = null;
      this.isRevealed = false;
      this.handleResize = () => {
        if (!this.isRevealed) {
          this.createVisibilityObserver();
        }
      };
    }
        
    connectedCallback() {
      this.init();
      window.addEventListener('resize', this.handleResize);
    }
        
    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.observer) this.observer.disconnect();
      this.clearAllTimeouts();
      window.removeEventListener('resize', this.handleResize);
    }

    clearAllTimeouts() {
      this.timeouts.forEach(timeout => clearTimeout(timeout));
      this.timeouts = [];
    }
        
    init() {
      this.wrapper = this.querySelector('.media-collage-scroll__grid');
      this.items = Array.from(this.querySelectorAll('.media'));
            
      this.initResizeObserver();
      this.createVisibilityObserver();
    }
        
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const height = entry.contentRect.height || entry.target.offsetHeight;
          entry.target.style.setProperty('--media-height', `${height}px`);
        }
      });
            
      this.items.forEach(item => this.resizeObserver.observe(item));
    }
        
    createVisibilityObserver() {
      if (this.observer) this.observer.disconnect();
            
      const isMobileSmall = DeviceUtils.isMobileSmall;
      const threshold = isMobileSmall ? 0 : 0.35;

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.revealItems();
            this.isRevealed = true;
            this.observer.unobserve(this);
          }
        });
      }, { 
        root: null, 
        threshold: threshold 
      });
            
      this.observer.observe(this);
    }
        
    revealItems() {
      this.clearAllTimeouts();
      this.items.forEach((item, index) => {
        const timeout = setTimeout(() => {
          item.classList.add('is-visible');
        }, index * 150);
        this.timeouts.push(timeout);
      });
    }
  });
}